<article>
    <ng-content></ng-content>
</article>